import React from 'react';

import { ApolloClient, createNetworkInterface, ApolloProvider } from 'react-apollo';
import { connect } from 'react-redux';

import ProgressReportRoute from './routes/ProgressReport';

const mapStateToProps = (state) => ({
  authedUserID: state.auth.sub || null,
  authedUser: state.auth || null,
});

export default (store) => {
  return ({
    path        : 'progress-report',
    component   : connect(mapStateToProps)(props => {
      let GraphQLURI = __GraphQLPublic || publicEndpoint; // eslint-disable-line no-undef
      if (props.authedUserID !== null) {
        GraphQLURI = __GraphQLProtected || protectedEndpoint; // eslint-disable-line no-undef
      }

      let ApolloNetworkInstance = createNetworkInterface({
        uri: GraphQLURI,
        opts: {
          headers: {
            'Authorization': 'Bearer ' + (props.authedUser.rawToken || 'unauthed'),
          }
        }
      });

      let ApolloClientInstance = new ApolloClient({
        networkInterface: ApolloNetworkInstance,
      });

      return (
        <ApolloProvider client={ApolloClientInstance}>
          {props.children}
        </ApolloProvider>
      );
    }),
    indexRoute  : ProgressReportRoute(store),
  });
};



// WEBPACK FOOTER //
// ./src/routes/progress-report/index.js